// extracted by mini-css-extract-plugin
module.exports = {"button":"Waffle-button-1wQQz","container":"Waffle-container-2hBld","row":"Waffle-row-CYw0u","square":"Waffle-square-2HaVn"};